import { gql, useMutation } from '@apollo/client';
import React, { ReactElement, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import alertPic from '../../../assets/alert.svg';
import GenericAlert from '../../../common_lib_front/components/genericAlert/genericAlert';
import { PopUp } from '../../../common_lib_front/components/popUp/popUp';
import style from './deleteDocument.module.css';

export const DELETE_USER_DOCUMENT_QUERY = gql`
  mutation deleteUserDocumentById($documentId: String!) {
    deleteUserDocumentById(documentId: $documentId) {
      success
      error
    }
  }
`;

export default function DeleteDocument(): ReactElement {
  const history = useHistory();
  const { docId } = useParams<{ docId: string }>();
  const [alert, setAlert] = useState<string>('');

  const [doDeleteDocument, { loading }] = useMutation(DELETE_USER_DOCUMENT_QUERY, {
    onError: e => {
      setAlert(e.message);
    },
    onCompleted: d => {
      if (d.deleteUserDocumentById.success) {
        history.goBack();
      } else {
        setAlert(d.deleteUserDocumentById.error);
      }
    },
  });
  return (
    <PopUp title="Delete Document" close={() => history.goBack()}>
      <div className={style.box}>
        <div className={style.alertBox}>
          <img src={alertPic} alt="" className={style.alertImg} />
          <h2>Warning:</h2>
          <h4 className={style.text}> Are you sure you want to delete the document ?</h4>
        </div>
        <GenericAlert color="red" title={alert} hidden={!alert} />
        <div className={style.btnBox}>
          <button onClick={() => history.goBack()} className={style.cancel}>
            Cancel
          </button>
          <button
            onClick={() => doDeleteDocument({ variables: { documentId: docId } })}
            className={style.delete}
          >
            Delete
          </button>
        </div>
      </div>
    </PopUp>
  );
}
